
// import React, { useCallback, useMemo, useState, useEffect } from "react";
// import { createEditor, Transforms, Editor, Element as SlateElement } from "slate";
// import { Slate, Editable, withReact, useSlate } from "slate-react";

// const DEFAULT_VALUE = [
//     {
//         type: "paragraph",
//         children: [{ text: "" }],
//     },
// ];

// // Helper functions để serialize/deserialize
// const serializeToHTML = (nodes) => {
//     return nodes.map(n => {
//         if (n.text !== undefined) {
//             let string = n.text;
//             if (n.bold) string = `<strong>${string}</strong>`;
//             if (n.italic) string = `<em>${string}</em>`;
//             if (n.underline) string = `<u>${string}</u>`;
//             return string;
//         }

//         const children = n.children.map(c => serializeToHTML([c])).join('');

//         switch (n.type) {
//             case 'paragraph':
//                 return `<p>${children}</p>`;
//             case 'heading-one':
//                 return `<h1>${children}</h1>`;
//             case 'heading-two':
//                 return `<h2>${children}</h2>`;
//             case 'block-quote':
//                 return `<blockquote>${children}</blockquote>`;
//             case 'bulleted-list':
//                 return `<ul>${children}</ul>`;
//             case 'numbered-list':
//                 return `<ol>${children}</ol>`;
//             case 'list-item':
//                 return `<li>${children}</li>`;
//             default:
//                 return children;
//         }
//     }).join('');
// };

// const deserializeFromString = (content) => {
//     // Nếu content là string, parse nó
//     if (typeof content === 'string') {
//         try {
//             // Thử parse JSON
//             const parsed = JSON.parse(content);
//             if (Array.isArray(parsed) && parsed.length > 0) {
//                 return parsed;
//             }
//         } catch {
//             // Nếu không phải JSON, coi như plain text
//             return [
//                 {
//                     type: "paragraph",
//                     children: [{ text: content }],
//                 },
//             ];
//         }
//     }

//     // Nếu đã là array
//     if (Array.isArray(content) && content.length > 0) {
//         return content;
//     }

//     return DEFAULT_VALUE;
// };

// const deserializeFromHTML = (html) => {
//     const div = document.createElement('div');
//     div.innerHTML = html;

//     const parseNode = (node) => {
//         if (node.nodeType === 3) return { text: node.textContent }; // text node
//         if (node.nodeType !== 1) return null;

//         let children = Array.from(node.childNodes).map(parseNode).filter(Boolean);

//         switch (node.nodeName) {
//             case 'STRONG': children = children.map(c => ({ ...c, bold: true })); break;
//             case 'EM': children = children.map(c => ({ ...c, italic: true })); break;
//             case 'U': children = children.map(c => ({ ...c, underline: true })); break;
//             case 'P': return { type: 'paragraph', children };
//             case 'H1': return { type: 'heading-one', children };
//             case 'H2': return { type: 'heading-two', children };
//             case 'BLOCKQUOTE': return { type: 'block-quote', children };
//             case 'UL': return { type: 'bulleted-list', children };
//             case 'OL': return { type: 'numbered-list', children };
//             case 'LI': return { type: 'list-item', children };
//             default: return { type: 'paragraph', children };
//         }

//         return { type: 'paragraph', children };
//     };

//     return Array.from(div.childNodes).map(parseNode).filter(Boolean);
// };



// const SlateEditor = ({ value, onChange, placeholder }) => {
//     const editor = useMemo(() => withReact(createEditor()), []);

//         // State nội bộ để quản lý giá trị
//     const [internalValue, setInternalValue] = useState(() => {
//         if (!value) return DEFAULT_VALUE;
        
//         // Kiểm tra xem value là HTML hay JSON
//         if (typeof value === 'string') {
//             // Nếu bắt đầu bằng < thì là HTML
//             if (value.trim().startsWith('<')) {
//                 return deserializeFromHTML(value);
//             }
//             // Nếu không thì thử parse JSON
//             return deserializeFromString(value);
//         }
//         return DEFAULT_VALUE;
//     });

//     // Sync external value vào internal khi value thay đổi (dùng cho edit mode)
//     useEffect(() => {
//         if (value && typeof value === 'string') {
//             if (value.trim().startsWith('<')) {
//                 setInternalValue(deserializeFromHTML(value));
//             } else {
//                 setInternalValue(deserializeFromString(value));
//             }
//         }
//     }, [value]); // Chạy khi value thay đổi



//     const handleChange = useCallback((newValue) => {
//         setInternalValue(newValue);

//         // Gọi onChange callback với cả JSON và HTML
//         const jsonString = JSON.stringify(newValue);
//         const htmlString = serializeToHTML(newValue);

//         // Bạn có thể chọn format nào muốn lưu
//         onChange(jsonString, htmlString);
//     }, [onChange]);

//     // Custom render elements
//     const renderElement = useCallback(props => <Element {...props} />, []);
//     const renderLeaf = useCallback(props => <Leaf {...props} />, []);

//     // Keyboard shortcuts
//     const handleKeyDown = useCallback((event) => {
//         if (event.ctrlKey || event.metaKey) {
//             switch (event.key) {
//                 case 'b': {
//                     event.preventDefault();
//                     toggleMark(editor, 'bold');
//                     break;
//                 }
//                 case 'i': {
//                     event.preventDefault();
//                     toggleMark(editor, 'italic');
//                     break;
//                 }
//                 case 'u': {
//                     event.preventDefault();
//                     toggleMark(editor, 'underline');
//                     break;
//                 }
//             }
//         }
//     }, [editor]);

//     return (
//         <div style={{
//             border: "1px solid #CBD5E1",
//             borderRadius: 6,
//             overflow: 'hidden'
//         }}>
//             <Slate
//                 editor={editor}
//                 initialValue={internalValue}
//                 value={internalValue}
//                 onChange={handleChange}
//             >
//                 {/* Toolbar - phải ở trong <Slate> để dùng useSlate */}
//                 <div style={{
//                     padding: '8px 12px',
//                     borderBottom: '1px solid #CBD5E1',
//                     backgroundColor: '#F8FAFC',
//                     display: 'flex',
//                     gap: '8px',
//                     flexWrap: 'wrap'
//                 }}>
//                     <MarkButton format="bold" icon="B" />
//                     <MarkButton format="italic" icon="I" />
//                     <MarkButton format="underline" icon="U" />
//                     <div style={{ width: 1, height: 24, backgroundColor: '#CBD5E1', margin: '0 4px' }} />
//                     <BlockButton format="heading-one" icon="H1" />
//                     <BlockButton format="heading-two" icon="H2" />
//                     <BlockButton format="block-quote" icon="❝❞" />
//                     <BlockButton format="numbered-list" icon="1." />
//                     <BlockButton format="bulleted-list" icon="•" />
//                 </div>

//                 {/* Editor */}
//                 <Editable
//                     renderElement={renderElement}
//                     renderLeaf={renderLeaf}
//                     placeholder={placeholder || "Nhập nội dung..."}
//                     onKeyDown={handleKeyDown}
//                     style={{
//                         minHeight: 200,
//                         padding: '12px 16px',
//                         fontFamily: 'Roboto, -apple-system, sans-serif',
//                         fontSize: 14,
//                         lineHeight: 1.6,
//                         outline: 'none'
//                     }}
//                 />
//             </Slate>
//         </div>
//     );
// };

// // Toggle marks (bold, italic, underline)
// const toggleMark = (editor, format) => {
//     const isActive = isMarkActive(editor, format);
//     if (isActive) {
//         Editor.removeMark(editor, format);
//     } else {
//         Editor.addMark(editor, format, true);
//     }
// };

// const isMarkActive = (editor, format) => {
//     const marks = Editor.marks(editor);
//     return marks ? marks[format] === true : false;
// };

// // Toggle blocks (headings, lists, etc)
// const toggleBlock = (editor, format) => {
//     const isActive = isBlockActive(editor, format);
//     const isList = ['numbered-list', 'bulleted-list'].includes(format);

//     Transforms.unwrapNodes(editor, {
//         match: n =>
//             !Editor.isEditor(n) &&
//             SlateElement.isElement(n) &&
//             ['numbered-list', 'bulleted-list'].includes(n.type),
//         split: true,
//     });

//     const newProperties = {
//         type: isActive ? 'paragraph' : isList ? 'list-item' : format,
//     };

//     Transforms.setNodes(editor, newProperties);

//     if (!isActive && isList) {
//         const block = { type: format, children: [] };
//         Transforms.wrapNodes(editor, block);
//     }
// };

// const isBlockActive = (editor, format) => {
//     const { selection } = editor;
//     if (!selection) return false;

//     const [match] = Array.from(
//         Editor.nodes(editor, {
//             at: Editor.unhangRange(editor, selection),
//             match: n =>
//                 !Editor.isEditor(n) && SlateElement.isElement(n) && n.type === format,
//         })
//     );

//     return !!match;
// };

// // Render components
// const Element = ({ attributes, children, element }) => {
//     switch (element.type) {
//         case 'block-quote':
//             return (
//                 <blockquote
//                     {...attributes}
//                     style={{
//                         borderLeft: '3px solid #ddd',
//                         paddingLeft: 16,
//                         margin: '8px 0',
//                         fontStyle: 'italic',
//                         color: '#666'
//                     }}
//                 >
//                     {children}
//                 </blockquote>
//             );
//         case 'bulleted-list':
//             return <ul {...attributes} style={{ paddingLeft: 24 }}>{children}</ul>;
//         case 'heading-one':
//             return <h1 {...attributes} style={{ fontSize: 28, margin: '16px 0 8px' }}>{children}</h1>;
//         case 'heading-two':
//             return <h2 {...attributes} style={{ fontSize: 22, margin: '12px 0 8px' }}>{children}</h2>;
//         case 'list-item':
//             return <li {...attributes} style={{ margin: '4px 0' }}>{children}</li>;
//         case 'numbered-list':
//             return <ol {...attributes} style={{ paddingLeft: 24 }}>{children}</ol>;
//         default:
//             return <p {...attributes} style={{ margin: '8px 0' }}>{children}</p>;
//     }
// };

// const Leaf = ({ attributes, children, leaf }) => {
//     if (leaf.bold) {
//         children = <strong>{children}</strong>;
//     }
//     if (leaf.italic) {
//         children = <em>{children}</em>;
//     }
//     if (leaf.underline) {
//         children = <u>{children}</u>;
//     }
//     return <span {...attributes}>{children}</span>;
// };

// // Toolbar buttons
// const MarkButton = ({ format, icon }) => {
//     const editor = useSlate();
//     const isActive = isMarkActive(editor, format);

//     return (
//         <button
//             type="button"
//             onMouseDown={(e) => {
//                 e.preventDefault();
//                 toggleMark(editor, format);
//             }}
//             style={{
//                 padding: '4px 8px',
//                 border: '1px solid #CBD5E1',
//                 borderRadius: 4,
//                 backgroundColor: isActive ? '#0070D7' : 'white',
//                 color: isActive ? 'white' : 'black',
//                 cursor: 'pointer',
//                 fontSize: 14,
//                 fontWeight: format === 'bold' ? 'bold' : 'normal',
//                 fontStyle: format === 'italic' ? 'italic' : 'normal',
//                 textDecoration: format === 'underline' ? 'underline' : 'none',
//             }}
//         >
//             {icon}
//         </button>
//     );
// };

// const BlockButton = ({ format, icon }) => {
//     const editor = useSlate();
//     const isActive = isBlockActive(editor, format);

//     return (
//         <button
//             type="button"
//             onMouseDown={(e) => {
//                 e.preventDefault();
//                 toggleBlock(editor, format);
//             }}
//             style={{
//                 padding: '4px 8px',
//                 border: '1px solid #CBD5E1',
//                 borderRadius: 4,
//                 backgroundColor: isActive ? '#0070D7' : 'white',
//                 color: isActive ? 'white' : 'black',
//                 cursor: 'pointer',
//                 fontSize: 14,
//             }}
//         >
//             {icon}
//         </button>
//     );
// };

// export default SlateEditor;


import React, { useCallback, useMemo, useState, useEffect } from "react";
import { createEditor, Transforms, Editor, Element as SlateElement, Range } from "slate";
import { Slate, Editable, withReact, useSlate } from "slate-react";

const DEFAULT_VALUE = [
    {
        type: "paragraph",
        children: [{ text: "" }],
    },
];

// Helper functions để serialize/deserialize
const serializeToHTML = (nodes) => {
    return nodes.map(n => {
        if (n.text !== undefined) {
            let string = n.text;
            if (n.code) string = `<code>${string}</code>`;
            if (n.bold) string = `<strong>${string}</strong>`;
            if (n.italic) string = `<em>${string}</em>`;
            if (n.underline) string = `<u>${string}</u>`;
            if (n.strikethrough) string = `<s>${string}</s>`;
            if (n.color) string = `<span style="color:${n.color}">${string}</span>`;
            if (n.backgroundColor) string = `<span style="background-color:${n.backgroundColor}">${string}</span>`;
            return string;
        }

        const children = n.children.map(c => serializeToHTML([c])).join('');
        const align = n.align ? ` style="text-align:${n.align}"` : '';

        switch (n.type) {
            case 'paragraph':
                return `<p${align}>${children}</p>`;
            case 'heading-one':
                return `<h1${align}>${children}</h1>`;
            case 'heading-two':
                return `<h2${align}>${children}</h2>`;
            case 'heading-three':
                return `<h3${align}>${children}</h3>`;
            case 'block-quote':
                return `<blockquote${align}>${children}</blockquote>`;
            case 'code-block':
                return `<pre><code>${children}</code></pre>`;
            case 'bulleted-list':
                return `<ul>${children}</ul>`;
            case 'numbered-list':
                return `<ol>${children}</ol>`;
            case 'list-item':
                return `<li${align}>${children}</li>`;
            case 'link':
                return `<a href="${n.url}">${children}</a>`;
            case 'image':
                return `<img src="${n.url}" alt="${n.alt || ''}" style="max-width:100%" />`;
            case 'horizontal-rule':
                return '<hr />';
            default:
                return children;
        }
    }).join('');
};

const deserializeFromString = (content) => {
    if (typeof content === 'string') {
        try {
            const parsed = JSON.parse(content);
            if (Array.isArray(parsed) && parsed.length > 0) {
                return parsed;
            }
        } catch {
            return [
                {
                    type: "paragraph",
                    children: [{ text: content }],
                },
            ];
        }
    }

    if (Array.isArray(content) && content.length > 0) {
        return content;
    }

    return DEFAULT_VALUE;
};

// const deserializeFromHTML = (html) => {
//     const div = document.createElement('div');
//     div.innerHTML = html;

//     const parseNode = (node) => {
//         if (node.nodeType === 3) return { text: node.textContent };
//         if (node.nodeType !== 1) return null;

//         let children = Array.from(node.childNodes).map(parseNode).filter(Boolean);
        
//         // Ensure all block elements have valid children
//         const ensureChildren = () => {
//             console.log('children.length', children.length)
//             if (children.length === 0) return [{ text: '' }];
//             // Flatten arrays of text nodes
//             return children.flat();
//         };

//         const style = node.style;
//         const align = style?.textAlign || null;

//         switch (node.nodeName) {
//             case 'STRONG': case 'B': 
//                 return children.map(c => ({ ...c, bold: true }));
//             case 'EM': case 'I': 
//                 return children.map(c => ({ ...c, italic: true }));
//             case 'U': 
//                 return children.map(c => ({ ...c, underline: true }));
//             case 'S': case 'STRIKE': case 'DEL':
//                 return children.map(c => ({ ...c, strikethrough: true }));
//             case 'CODE':
//                 if (node.parentNode.nodeName === 'PRE') return children;
//                 return children.map(c => ({ ...c, code: true }));
//             case 'SPAN':
//                 const color = style?.color;
//                 const bgColor = style?.backgroundColor;
//                 return children.map(c => ({
//                     ...c,
//                     ...(color && { color }),
//                     ...(bgColor && { backgroundColor: bgColor })
//                 }));
//             case 'P': 
//                 return { type: 'paragraph', align, children: ensureChildren() };
//             case 'H1': 
//                 return { type: 'heading-one', align, children: ensureChildren() };
//             case 'H2': 
//                 return { type: 'heading-two', align, children: ensureChildren() };
//             case 'H3': 
//                 return { type: 'heading-three', align, children: ensureChildren() };
//             case 'BLOCKQUOTE': 
//                 return { type: 'block-quote', align, children: ensureChildren() };
//             case 'PRE':
//                 return { type: 'code-block', children: ensureChildren() };
//             case 'UL': 
//                 return { type: 'bulleted-list', children: ensureChildren() };
//             case 'OL': 
//                 return { type: 'numbered-list', children: ensureChildren() };
//             case 'LI': 
//                 return { type: 'list-item', align, children: ensureChildren() };
//             case 'A':
//                 return { type: 'link', url: node.href, children: ensureChildren() };
//             case 'IMG':
//                 return { type: 'image', url: node.src, alt: node.alt, children: [{ text: '' }] };
//             case 'HR':
//                 return { type: 'horizontal-rule', children: [{ text: '' }] };
//             default: 
//                 return { type: 'paragraph', children: ensureChildren() };
//         }
//     };

//     const result = Array.from(div.childNodes).map(parseNode).filter(Boolean).flat();
//     return result.length > 0 ? result : DEFAULT_VALUE;
// };

const deserializeFromHTML = (html) => {
    const div = document.createElement('div');
    div.innerHTML = html;

    const wrapTextMarks = (children, marks = {}) => {
        return children
            .map(c => {
                if (!c) return null;
                if (Array.isArray(c)) return wrapTextMarks(c, marks);
                if (!c.text) return c;
                return { ...c, ...marks };
            })
            .flat();
    };

    const parseNode = (node) => {
        if (node.nodeType === 3) return { text: node.textContent };
        if (node.nodeType !== 1) return null;

        let children = Array.from(node.childNodes).map(parseNode).filter(Boolean);

        const ensureChildren = () => {
            if (!children || children.length === 0) return [{ text: '' }];
            return children.flat();
        };

        const style = node.style;
        const align = style?.textAlign || null;

        switch (node.nodeName) {
            case 'STRONG':
            case 'B':
                return wrapTextMarks(children, { bold: true });

            case 'EM':
            case 'I':
                return wrapTextMarks(children, { italic: true });

            case 'U':
                return wrapTextMarks(children, { underline: true });

            case 'S':
            case 'STRIKE':
            case 'DEL':
                return wrapTextMarks(children, { strikethrough: true });

            case 'CODE':
                if (node.parentNode.nodeName === 'PRE') return children;
                return wrapTextMarks(children, { code: true });

            case 'SPAN':
                return wrapTextMarks(children, {
                    ...(style?.color && { color: style.color }),
                    ...(style?.backgroundColor && { backgroundColor: style.backgroundColor })
                });

            case 'P':
                return { type: 'paragraph', align, children: ensureChildren() };

            case 'H1':
                return { type: 'heading-one', align, children: ensureChildren() };

            case 'H2':
                return { type: 'heading-two', align, children: ensureChildren() };

            case 'H3':
                return { type: 'heading-three', align, children: ensureChildren() };

            case 'BLOCKQUOTE':
                return { type: 'block-quote', align, children: ensureChildren() };

            case 'PRE':
                return { type: 'code-block', children: ensureChildren() };

            case 'UL':
                return { type: 'bulleted-list', children: ensureChildren() };

            case 'OL':
                return { type: 'numbered-list', children: ensureChildren() };

            case 'LI':
                return { type: 'list-item', align, children: ensureChildren() };

            case 'A':
                return { type: 'link', url: node.href, children: ensureChildren() };

            case 'IMG':
                return {
                    type: 'image',
                    url: node.src,
                    alt: node.alt,
                    children: [{ text: '' }]
                };

            case 'HR':
                return { type: 'horizontal-rule', children: [{ text: '' }] };

            default:
                return { type: 'paragraph', children: ensureChildren() };
        }
    };

    const result = Array.from(div.childNodes).map(parseNode).filter(Boolean).flat();
    return result.length > 0 ? result : DEFAULT_VALUE;
};


// Custom withLinks plugin
const withLinks = editor => {
    const { isInline, isVoid } = editor;
    
    editor.isInline = element => {
        return element.type === 'link' ? true : isInline(element);
    };
    
    return editor;
};

// Custom withImages plugin
const withImages = editor => {
    const { isVoid, isInline } = editor;
    
    editor.isVoid = element => {
        return ['image', 'horizontal-rule'].includes(element.type) ? true : isVoid(element);
    };
    
    editor.isInline = element => {
        return element.type === 'link' ? true : isInline(element);
    };
    
    return editor;
};

const SlateEditor = ({ value, onChange, placeholder }) => {
    const editor = useMemo(() => withImages(withReact(createEditor())), []);
    const [showColorPicker, setShowColorPicker] = useState(false);
    const [showBgColorPicker, setShowBgColorPicker] = useState(false);
    const [linkUrl, setLinkUrl] = useState('');
    const [showLinkInput, setShowLinkInput] = useState(false);

    const [internalValue, setInternalValue] = useState(() => {
        if (!value) return DEFAULT_VALUE;
        
        if (typeof value === 'string') {
            if (value.trim().startsWith('<')) {
                return deserializeFromHTML(value);
            }
            return deserializeFromString(value);
        }
        return DEFAULT_VALUE;
    });

    useEffect(() => {
        if (value && typeof value === 'string') {
            if (value.trim().startsWith('<')) {
                setInternalValue(deserializeFromHTML(value));
            } else {
                setInternalValue(deserializeFromString(value));
            }
        }
    }, [value]);

    const handleChange = useCallback((newValue) => {
        setInternalValue(newValue);
        const jsonString = JSON.stringify(newValue);
        const htmlString = serializeToHTML(newValue);
        onChange(jsonString, htmlString);
    }, [onChange]);

    const renderElement = useCallback(props => <Element {...props} />, []);
    const renderLeaf = useCallback(props => <Leaf {...props} />, []);

    const handleKeyDown = useCallback((event) => {
        if (event.ctrlKey || event.metaKey) {
            switch (event.key) {
                case 'b': {
                    event.preventDefault();
                    toggleMark(editor, 'bold');
                    break;
                }
                case 'i': {
                    event.preventDefault();
                    toggleMark(editor, 'italic');
                    break;
                }
                case 'u': {
                    event.preventDefault();
                    toggleMark(editor, 'underline');
                    break;
                }
                case '`': {
                    event.preventDefault();
                    toggleMark(editor, 'code');
                    break;
                }
            }
        }
    }, [editor]);

    return (
        <div style={{
            border: "1px solid #CBD5E1",
            borderRadius: 6,
            overflow: 'hidden'
        }}>
            <Slate
                editor={editor}
                initialValue={internalValue}
                value={internalValue}
                onChange={handleChange}
            >
                <div style={{
                    padding: '8px 12px',
                    borderBottom: '1px solid #CBD5E1',
                    backgroundColor: '#F8FAFC',
                    display: 'flex',
                    gap: '8px',
                    flexWrap: 'wrap',
                    alignItems: 'center'
                }}>
                    {/* Text formatting */}
                    <MarkButton format="bold" icon="B" title="Bold (Ctrl+B)" />
                    <MarkButton format="italic" icon="I" title="Italic (Ctrl+I)" />
                    <MarkButton format="underline" icon="U" title="Underline (Ctrl+U)" />
                    <MarkButton format="strikethrough" icon="S" title="Strikethrough" />
                    <MarkButton format="code" icon="</>" title="Code (Ctrl+`)" />
                    
                    <Divider />
                    
                    {/* Headings & blocks */}
                    <BlockButton format="heading-one" icon="H1" />
                    <BlockButton format="heading-two" icon="H2" />
                    <BlockButton format="heading-three" icon="H3" />
                    <BlockButton format="block-quote" icon="❝❞" />
                    <BlockButton format="code-block" icon="{ }" />
                    
                    <Divider />
                    
                    {/* Lists */}
                    <BlockButton format="numbered-list" icon="1." />
                    <BlockButton format="bulleted-list" icon="•" />
                    
                    <Divider />
                    
                    {/* Alignment */}
                    <AlignButton align="left" icon="≡" />
                    <AlignButton align="center" icon="≣" />
                    <AlignButton align="right" icon="≡" />
                    <AlignButton align="justify" icon="≣" />
                    
                    <Divider />
                    
                    {/* Colors */}
                    <ColorButton 
                        show={showColorPicker} 
                        setShow={setShowColorPicker}
                        isBackground={false}
                    />
                    <ColorButton 
                        show={showBgColorPicker} 
                        setShow={setShowBgColorPicker}
                        isBackground={true}
                    />
                    
                    <Divider />
                    
                    {/* Link */}
                    <LinkButton 
                        showInput={showLinkInput}
                        setShowInput={setShowLinkInput}
                        linkUrl={linkUrl}
                        setLinkUrl={setLinkUrl}
                    />
                    
                    {/* Image */}
                    <ImageButton />
                    
                    {/* HR */}
                    <HRButton />
                </div>

                <Editable
                    renderElement={renderElement}
                    renderLeaf={renderLeaf}
                    placeholder={placeholder || "Nhập nội dung..."}
                    onKeyDown={handleKeyDown}
                    style={{
                        minHeight: 300,
                        padding: '12px 16px',
                        fontFamily: 'Roboto, -apple-system, sans-serif',
                        fontSize: 14,
                        lineHeight: 1.6,
                        outline: 'none'
                    }}
                />
            </Slate>
        </div>
    );
};

// Toggle marks
const toggleMark = (editor, format) => {
    const isActive = isMarkActive(editor, format);
    if (isActive) {
        Editor.removeMark(editor, format);
    } else {
        Editor.addMark(editor, format, true);
    }
};

const isMarkActive = (editor, format) => {
    const marks = Editor.marks(editor);
    return marks ? marks[format] === true : false;
};

// Toggle blocks
const toggleBlock = (editor, format) => {
    const isActive = isBlockActive(editor, format);
    const isList = ['numbered-list', 'bulleted-list'].includes(format);

    Transforms.unwrapNodes(editor, {
        match: n =>
            !Editor.isEditor(n) &&
            SlateElement.isElement(n) &&
            ['numbered-list', 'bulleted-list'].includes(n.type),
        split: true,
    });

    const newProperties = {
        type: isActive ? 'paragraph' : isList ? 'list-item' : format,
    };

    Transforms.setNodes(editor, newProperties);

    if (!isActive && isList) {
        const block = { type: format, children: [] };
        Transforms.wrapNodes(editor, block);
    }
};

const isBlockActive = (editor, format) => {
    const { selection } = editor;
    if (!selection) return false;

    const [match] = Array.from(
        Editor.nodes(editor, {
            at: Editor.unhangRange(editor, selection),
            match: n =>
                !Editor.isEditor(n) && SlateElement.isElement(n) && n.type === format,
        })
    );

    return !!match;
};

// Alignment
const toggleAlign = (editor, align) => {
    Transforms.setNodes(
        editor,
        { align },
        { match: n => SlateElement.isElement(n) && Editor.isBlock(editor, n) }
    );
};

const isAlignActive = (editor, align) => {
    const [match] = Array.from(
        Editor.nodes(editor, {
            match: n => SlateElement.isElement(n) && n.align === align,
        })
    );
    return !!match;
};

// Link functions
const insertLink = (editor, url) => {
    if (!url) return;
    
    const { selection } = editor;
    const isCollapsed = selection && Range.isCollapsed(selection);

    const link = {
        type: 'link',
        url,
        children: isCollapsed ? [{ text: url }] : [],
    };

    if (isCollapsed) {
        Transforms.insertNodes(editor, link);
    } else {
        Transforms.wrapNodes(editor, link, { split: true });
        Transforms.collapse(editor, { edge: 'end' });
    }
};

const isLinkActive = (editor) => {
    const [link] = Editor.nodes(editor, {
        match: n => !Editor.isEditor(n) && SlateElement.isElement(n) && n.type === 'link',
    });
    return !!link;
};

const unwrapLink = (editor) => {
    Transforms.unwrapNodes(editor, {
        match: n => !Editor.isEditor(n) && SlateElement.isElement(n) && n.type === 'link',
    });
};

// Image functions
const insertImage = (editor, url) => {
    const image = { type: 'image', url, alt: '', children: [{ text: '' }] };
    Transforms.insertNodes(editor, image);
    Transforms.insertNodes(editor, { type: 'paragraph', children: [{ text: '' }] });
};

// HR function
const insertHR = (editor) => {
    const hr = { type: 'horizontal-rule', children: [{ text: '' }] };
    Transforms.insertNodes(editor, hr);
    Transforms.insertNodes(editor, { type: 'paragraph', children: [{ text: '' }] });
};

// Render components
const Element = ({ attributes, children, element }) => {
    const style = element.align ? { textAlign: element.align } : {};
    
    switch (element.type) {
        case 'block-quote':
            return (
                <blockquote
                    {...attributes}
                    style={{
                        ...style,
                        borderLeft: '3px solid #ddd',
                        paddingLeft: 16,
                        margin: '8px 0',
                        fontStyle: 'italic',
                        color: '#666'
                    }}
                >
                    {children}
                </blockquote>
            );
        case 'code-block':
            return (
                <pre
                    {...attributes}
                    style={{
                        backgroundColor: '#f4f4f4',
                        padding: 12,
                        borderRadius: 4,
                        overflow: 'auto',
                        fontFamily: 'monospace'
                    }}
                >
                    <code>{children}</code>
                </pre>
            );
        case 'bulleted-list':
            return <ul {...attributes} style={{ paddingLeft: 24 }}>{children}</ul>;
        case 'heading-one':
            return <h1 {...attributes} style={{ ...style, fontSize: 28, margin: '16px 0 8px' }}>{children}</h1>;
        case 'heading-two':
            return <h2 {...attributes} style={{ ...style, fontSize: 22, margin: '12px 0 8px' }}>{children}</h2>;
        case 'heading-three':
            return <h3 {...attributes} style={{ ...style, fontSize: 18, margin: '10px 0 6px' }}>{children}</h3>;
        case 'list-item':
            return <li {...attributes} style={{ ...style, margin: '4px 0' }}>{children}</li>;
        case 'numbered-list':
            return <ol {...attributes} style={{ paddingLeft: 24 }}>{children}</ol>;
        case 'link':
            return (
                <a {...attributes} href={element.url} style={{ color: '#0070D7', textDecoration: 'underline' }}>
                    {children}
                </a>
            );
        case 'image':
            return (
                <div {...attributes} contentEditable={false} style={{ margin: '8px 0' }}>
                    <img 
                        src={element.url} 
                        alt={element.alt || ''} 
                        style={{ maxWidth: '100%', display: 'block' }}
                    />
                    {children}
                </div>
            );
        case 'horizontal-rule':
            return (
                <div {...attributes} contentEditable={false} style={{ margin: '16px 0' }}>
                    <hr style={{ border: 'none', borderTop: '1px solid #ddd' }} />
                    {children}
                </div>
            );
        default:
            return <p {...attributes} style={{ ...style, margin: '8px 0' }}>{children}</p>;
    }
};

const Leaf = ({ attributes, children, leaf }) => {
    if (leaf.bold) children = <strong>{children}</strong>;
    if (leaf.italic) children = <em>{children}</em>;
    if (leaf.underline) children = <u>{children}</u>;
    if (leaf.strikethrough) children = <s>{children}</s>;
    if (leaf.code) children = <code style={{ backgroundColor: '#f4f4f4', padding: '2px 4px', borderRadius: 3, fontFamily: 'monospace' }}>{children}</code>;
    
    const style = {};
    if (leaf.color) style.color = leaf.color;
    if (leaf.backgroundColor) style.backgroundColor = leaf.backgroundColor;
    
    return <span {...attributes} style={style}>{children}</span>;
};

// Toolbar components
const toolbarButtonStyle = (isActive) => ({
    padding: '4px 8px',
    border: '1px solid #CBD5E1',
    borderRadius: 4,
    backgroundColor: isActive ? '#0070D7' : 'white',
    color: isActive ? 'white' : 'black',
    cursor: 'pointer',
    fontSize: 14,
    minWidth: 28,
    textAlign: 'center'
});

const Divider = () => (
    <div style={{ width: 1, height: 24, backgroundColor: '#CBD5E1', margin: '0 4px' }} />
);

const MarkButton = ({ format, icon, title }) => {
    const editor = useSlate();
    const isActive = isMarkActive(editor, format);

    return (
        <button
            type="button"
            onMouseDown={(e) => {
                e.preventDefault();
                toggleMark(editor, format);
            }}
            style={{
                ...toolbarButtonStyle(isActive),
                fontWeight: format === 'bold' ? 'bold' : 'normal',
                fontStyle: format === 'italic' ? 'italic' : 'normal',
                textDecoration: format === 'underline' ? 'underline' : format === 'strikethrough' ? 'line-through' : 'none',
            }}
            title={title}
        >
            {icon}
        </button>
    );
};

const BlockButton = ({ format, icon }) => {
    const editor = useSlate();
    const isActive = isBlockActive(editor, format);

    return (
        <button
            type="button"
            onMouseDown={(e) => {
                e.preventDefault();
                toggleBlock(editor, format);
            }}
            style={toolbarButtonStyle(isActive)}
        >
            {icon}
        </button>
    );
};

const AlignButton = ({ align, icon }) => {
    const editor = useSlate();
    const isActive = isAlignActive(editor, align);

    return (
        <button
            type="button"
            onMouseDown={(e) => {
                e.preventDefault();
                toggleAlign(editor, align);
            }}
            style={toolbarButtonStyle(isActive)}
            title={`Align ${align}`}
        >
            {icon}
        </button>
    );
};

const ColorButton = ({ show, setShow, isBackground }) => {
    const editor = useSlate();
    const colors = ['#000000', '#ff0000', '#00ff00', '#0000ff', '#ffff00', '#ff00ff', '#00ffff', '#ffffff'];

    return (
        <div style={{ position: 'relative' }}>
            <button
                type="button"
                onClick={(e) => {
                    e.preventDefault();
                    setShow(!show);
                }}
                style={toolbarButtonStyle(false)}
                title={isBackground ? 'Background Color' : 'Text Color'}
            >
                {isBackground ? '🎨' : 'A'}
            </button>
            {show && (
                <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    zIndex: 1000,
                    backgroundColor: 'white',
                    border: '1px solid #CBD5E1',
                    borderRadius: 4,
                    padding: 8,
                    display: 'grid',
                    gridTemplateColumns: 'repeat(4, 1fr)',
                    gap: 4,
                    marginTop: 4
                }}>
                    {colors.map(color => (
                        <button
                            key={color}
                            type="button"
                            onMouseDown={(e) => {
                                e.preventDefault();
                                Editor.addMark(editor, isBackground ? 'backgroundColor' : 'color', color);
                                setShow(false);
                            }}
                            style={{
                                width: 24,
                                height: 24,
                                backgroundColor: color,
                                border: '1px solid #ccc',
                                cursor: 'pointer',
                                borderRadius: 2
                            }}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

const LinkButton = ({ showInput, setShowInput, linkUrl, setLinkUrl }) => {
    const editor = useSlate();
    const isActive = isLinkActive(editor);

    return (
        <div style={{ position: 'relative' }}>
            <button
                type="button"
                onClick={(e) => {
                    e.preventDefault();
                    if (isActive) {
                        unwrapLink(editor);
                    } else {
                        setShowInput(!showInput);
                    }
                }}
                style={toolbarButtonStyle(isActive)}
                title="Insert Link"
            >
                🔗
            </button>
            {showInput && (
                <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    zIndex: 1000,
                    backgroundColor: 'white',
                    border: '1px solid #CBD5E1',
                    borderRadius: 4,
                    padding: 8,
                    marginTop: 4,
                    minWidth: 250
                }}>
                    <input
                        type="url"
                        value={linkUrl}
                        onChange={(e) => setLinkUrl(e.target.value)}
                        placeholder="https://example.com"
                        style={{
                            width: '100%',
                            padding: '4px 8px',
                            border: '1px solid #CBD5E1',
                            borderRadius: 4,
                            marginBottom: 4
                        }}
                    />
                    <button
                        type="button"
                        onClick={(e) => {
                            e.preventDefault();
                            insertLink(editor, linkUrl);
                            setLinkUrl('');
                            setShowInput(false);
                        }}
                        style={{
                            width: '100%',
                            padding: '4px 8px',
                            backgroundColor: '#0070D7',
                            color: 'white',
                            border: 'none',
                            borderRadius: 4,
                            cursor: 'pointer'
                        }}
                    >
                        Insert
                    </button>
                </div>
            )}
        </div>
    );
};

const ImageButton = () => {
    const editor = useSlate();
    const [imageUrl, setImageUrl] = useState('');
    const [showInput, setShowInput] = useState(false);

    return (
        <div style={{ position: 'relative' }}>
            <button
                type="button"
                onClick={(e) => {
                    e.preventDefault();
                    setShowInput(!showInput);
                }}
                style={toolbarButtonStyle(false)}
                title="Insert Image"
            >
                🖼️
            </button>
            {showInput && (
                <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    zIndex: 1000,
                    backgroundColor: 'white',
                    border: '1px solid #CBD5E1',
                    borderRadius: 4,
                    padding: 8,
                    marginTop: 4,
                    minWidth: 250
                }}>
                    <input
                        type="url"
                        value={imageUrl}
                        onChange={(e) => setImageUrl(e.target.value)}
                        placeholder="Image URL"
                        style={{
                            width: '100%',
                            padding: '4px 8px',
                            border: '1px solid #CBD5E1',
                            borderRadius: 4,
                            marginBottom: 4
                        }}
                    />
                    <button
                        type="button"
                        onClick={(e) => {
                            e.preventDefault();
                            insertImage(editor, imageUrl);
                            setImageUrl('');
                            setShowInput(false);
                        }}
                        style={{
                            width: '100%',
                            padding: '4px 8px',
                            backgroundColor: '#0070D7',
                            color: 'white',
                            border: 'none',
                            borderRadius: 4,
                            cursor: 'pointer'
                        }}
                    >
                        Insert
                    </button>
                </div>
            )}
        </div>
    );
};

const HRButton = () => {
    const editor = useSlate();

    return (
        <button
            type="button"
            onMouseDown={(e) => {
                e.preventDefault();
                insertHR(editor);
            }}
            style={toolbarButtonStyle(false)}
            title="Insert Horizontal Rule"
        >
            ―
        </button>
    );
};

export default SlateEditor;